// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_ReorderImagesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/products/reorderImages
 *
 * Confirms the product whose gallery was reordered. The frontend
 * follows up with `listImages` to read back the new sort_order values
 * (the response intentionally omits the new order to keep the
 * envelope thin; the source of truth is the database).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Products_ReorderImagesResponseDados {
so_product_id: number
}

export type Products_ReorderImagesResponse = ApiResponse<Products_ReorderImagesResponseDados>;

registerResponseContract('Products_ReorderImagesResponse', {
  so_product_id: { type: 'number',  required: true },
})
